// import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
// import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { useState } from "react";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const defaultRateGradation = { from: 1, to: null, rate: null };

const CPA = ({ handleUpdata, index, item }) => {
    const [gradation, setGradation] = useState(item.rateGradationArray);

    const handleChangeValue = (value, key) => {
        handleUpdata(index, { ...item, [key]: value });
    };

    const handleChangeGradationValue = (value, key, idx, el) => {
        const gr = gradation.map((gr, index) => (index === idx ? { ...gr, [key]: value, from: key === "to" ? (idx ? gradation[index - 1].to + 1 : 1) : gr.from } : gr));
        console.log(gr);

        setGradation(gr);
        handleUpdata(index, { ...item, rateGradationArray: gr });
    };

    const handleAddGradation = () => {
        handleUpdata(index, { ...item, rateGradationArray: item.rateGradationArray.concat(defaultRateGradation) });
        setGradation(gradation.concat(defaultRateGradation));
    };

    const handlePopGradation = (idx) => {
        const gr = item.rateGradationArray.filter((gradation, index) => index !== idx);
        setGradation(gr);
        handleUpdata(index, { ...item, rateGradationArray: gr });
    };

    return (
        <div className="cpo__block">
            {/* <div className="block__input">
                <label>Выберите опции ставки*</label>
                <div className="radio__block">
                    {radioButton.map((i, key) => (
                        <div className="radio__item" key={key}>
                            <RadioButton value={i.value} onChange={(e) => handleChangeValue(e.value, "cpoType")} checked={item.cpoType === i.value} />
                            <label>{i.label}</label>
                        </div>
                    ))}
                </div>
            </div> */}

            {item.cpoType === "rubPerOrder" ? (
                <div className="block__input">
                    <label>Укажите ставку без НДС*</label>
                    <InputNumber locale="ru-RU" placeholder="0" mode="currency" currency="RUB" onChange={(e) => handleChangeValue(e.value, "rate")} />
                    <span className="desc">{item.rate ? (item.rate * 1.22).toFixed(2) + "₽ с НДС" : "Здесь появится стоимость с НДС"}</span>
                </div>
            ) : null}

            {item.cpoType === "rateGradation" ? (
                <>
                    {item.rateGradationArray.map((el, idx) => (
                        <div className="block__input grad" key={idx}>
                            {!idx ? <label>Стоимость с НДС*</label> : null}
                            <div className="rate__gradation">
                                <span>от</span>
                                <InputNumber placeholder="0" className="input_gradation" value={idx === 0 ? 1 : item.rateGradationArray[idx - 1]?.to + 1} disabled />
                                <span>до</span>
                                <InputNumber placeholder="0" locale="ru-RU" onChange={(e) => handleChangeGradationValue(e.value, "to", idx, el)} value={el.to} />
                                <span>ЦД </span>
                                <div className="rate__gradation-block">
                                    <InputNumber placeholder="0" locale="ru-RU" mode="currency" currency="RUB" onChange={(e) => handleChangeGradationValue(e.value, "rate", idx, el)} value={el.rate} />
                                    <span className="desc">{el.rate ? (el.rate * 1.22).toFixed(2) + "₽ с НДС" : "Здесь появится стоимость с НДС"}</span>
                                </div>
                                {item.rateGradationArray.length > 1 ? <i className="pi pi-trash" onClick={() => handlePopGradation(idx)} /> : null}
                            </div>
                        </div>
                    ))}
                    <ButtonUI label="Добавить градацию" icon="pi pi-plus-circle" text onClick={handleAddGradation} style={{ marginBottom: "16px", width: "unset" }} disabled={!item.rateGradationArray[item.rateGradationArray.length - 1].to} />
                </>
            ) : null}

            {item.cpoType === "percentAmount" ? (
                <div className="block__input">
                    <label>Укажите % от суммы заказа*</label>
                    <InputNumber value={item.percentAmount} onValueChange={(e) => handleChangeValue(e.value, "percentAmount")} suffix="%" minFractionDigits={2} max={100} />
                </div>
            ) : null}

            <div className="block__input">
                <label>Опишите к чему привязана ставка* (это поможет найти нужную ставку при заведение оффера)</label>
                <InputText id="comments" placeholder="Укажите комментарий" value={item.comments} onChange={(e) => handleChangeValue(e.target.value, "comments")} />
            </div>

            {/* <div className="block__input">
                <label>Укажите период действия ставки*</label>
                <div className="block__switch">
                    <InputSwitch checked={item.indefinitely} onChange={(e) => handleChangeValue(e.value, "indefinitely")} />
                    <label>Бессрочно</label>
                </div>
            </div> */}

            {/* <div className="block__date">
                <div className={`date__item`}>
                    <label>Дата начала*</label>
                    <Calendar mask={"99.99.9999"} value={item.dateStart} onChange={(e) => onChangeCalendar(e.value, "dateStart")} dateFormat="dd.mm.yy" locale="rus" timeOnly={false} />
                </div>
                {!item.indefinitely ? (
                    <div className={`date__item`}>
                        <label>Дата окончания *</label>
                        <Calendar mask={"99.99.9999"} value={item.dateEnd} onChange={(e) => onChangeCalendar(e.value, "dateEnd")} dateFormat="dd.mm.yy" locale="rus" timeOnly={false} />
                    </div>
                ) : null}
            </div> */}
        </div>
    );
};

// const radioButton = [
//     { label: "руб. за заказ", value: "rubPerOrder" },
//     // { label: "Градация ставок", value: "rateGradation" },
//     // { label: "% от суммы заказа", value: "percentAmount" },
// ];

export default CPA;
